var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.statistic.show)?_c('td',{class:_vm.theClass,attrs:{"aria-label":_vm.statistic.ariaLabel,"title":_vm.statistic.hoverTitle}},[_vm._v(" "+_vm._s(_vm.statistic.footnote)+" "+_vm._s(_vm.statistic.formattedValue)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }